import React from "react";
import { MapContainer, MapConsumer, TileLayer, useMapEvents } from "react-leaflet";
import { withMapControl } from "../containers/containerMapControl";
import styles from "./mapWrapper.module.scss";
import { withAppState } from "../containers/containerAppState";
import { CRS } from "leaflet";
import config from "../services/apiConfig";
import WithToken from "../services/tokenService";
import { withAuth } from "../containers/containerAuth";
import { withVideoTools } from "../containers/containerVideoTools";
import { withRouteSpeedColor } from "../containers/containerRouteSpeedColor";

function ZoomComponent(props) {
  const { onSetZoom, onSetMapCenter, routeSpeedColor } = props;

  const mapEvents = useMapEvents({
    zoomend: (e) => {
      if (!routeSpeedColor.isOn) {
        onSetZoom(mapEvents.getZoom());
        onSetMapCenter(mapEvents._lastCenter);
      }
    },
  });

  return null;
}

const MapWrapper = (props) => {
  const { mapBaseLayer, zoom, mapCenter, mapBounds, isSideBarOpen, isViewCustomMap, data, onSetZoom, onSetMapCenter, routeSpeedColor } =
    props;

  const customMapTileUrl = config.get("baseURL") + "/CustomMapTiles/{z}/{x}/{y}?Token=" + WithToken.getToken("authTNToken");
  const isAccessCustomMapTile = data.permissions.includes(44001);

  return (
    <React.Fragment>
      <MapContainer
        key={`${mapBaseLayer.name} ${mapCenter.lat} ${mapCenter.lng}  ${isSideBarOpen}`}
        center={mapCenter}
        zoom={zoom}
        maxZoom={mapBaseLayer.maxZoom}
        minZoom={3}
        crs={mapBaseLayer.crs}
        zoomControl={true}
        attributionControl={false}
        doubleClickZoom={true}
        scrollWheelZoom={true}
        dragging={true}
        animate={true}
        easeLinearity={0.35}
        className={styles.mapWrapper}
      >
        <MapConsumer>
          {(map) => {
            if (mapBounds !== null) {
              map.fitBounds(mapBounds.pad(1.5));
            }

            return null;
          }}
        </MapConsumer>

        <ZoomComponent onSetZoom={onSetZoom} onSetMapCenter={onSetMapCenter} routeSpeedColor={routeSpeedColor} />

        {mapBaseLayer.url.map((_url, index) => {
          return <TileLayer key={mapBaseLayer.name + index} url={_url} updateWhenIdle={true} maxZoom={mapBaseLayer.maxZoom} />;
        })}

        {isAccessCustomMapTile && isViewCustomMap && mapBaseLayer.crs === CRS.EPSG900913 ? (
          <TileLayer opacity={0.6} url={customMapTileUrl} updateWhenIdle={true} />
        ) : null}

        {props.children}
      </MapContainer>
    </React.Fragment>
  );
};

export default withRouteSpeedColor(withVideoTools(withAuth(withAppState(withMapControl(React.memo(MapWrapper))))));
